import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntegrationMap from "./components/IntegrationMap";
import Services from "./components/Services";
import Process from "./components/Process";
import TechStack from "./components/TechStack";
import Stats from "./components/Stats";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Industries from "./components/Industries";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <IntegrationMap />
      <Services />
      <Industries />
      <Process />
      <Stats />
      <TechStack />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
